import { motion } from 'framer-motion';
import { fadeIn } from "../styles/variants";
import { BsDownload } from 'react-icons/bs';
import { useEffect } from 'react';

const Resume = ({activeComp, setActiveComp, pageHeight = 100, refs}) => {
  const cvLinks = [
    {
      link: "https://drive.google.com/u/0/uc?id=1IH5nCxBIGW4s5MEJpKZVCD3S-cK0NjuS&export=download",
      title: "Short version"
    },
    {
      link: "https://drive.google.com/u/0/uc?id=18O42s5VvaX3myf2jG9PhL2MKVDjjrRWl&export=download",
      title: "Short version in Polish"
    },
    {
      link:"https://drive.google.com/u/0/uc?id=1NxeGgCfvgn4Aw_DfUhlgW0A3F-l4niKg&export=download",
      title: "Long version"
    }
  ]
  
  const observerMargin = Math.floor(pageHeight / 2);
  
  useEffect(() => {
    const observerConfig = {
      rootMargin: `-${
        pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin
      }px 0px -${observerMargin}px 0px`,
    };
    const handleIntersection = function(entries) {
      entries.forEach((entry) => {
        if (entry.target.id !== activeComp && entry.isIntersecting) {
          setActiveComp(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(
      handleIntersection,
      observerConfig
    );
    observer.observe(refs['resume'].current);
    return () => observer.disconnect(); // Clenaup the observer if component unmount.
  }, [
    activeComp,
    setActiveComp,
    observerMargin,
    refs,
    pageHeight
  ]);

  return (
  <section id="resume" ref={refs['resume']} className="section h-[100vh]">
    <div className='container mx-auto'>
      <div className='flex flex-col lg:flex-row gap-x-10'>
      {/*resume pdf*/}
        <motion.div 
          variants={fadeIn('right', 0.5)} 
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.3 }}
          className='flex-1'
        >
          <iframe title="Resume pdf" src="https://drive.google.com/file/d/1IH5nCxBIGW4s5MEJpKZVCD3S-cK0NjuS/preview" allow="autoplay" className='hidden lg:flex flex-1 lg:h-[900px] lg:w-[640px]'></iframe> 
        </motion.div>
      {/*text*/}
        <motion.div 
          variants={fadeIn('left', 0.3)} 
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.3 }}
          className='flex-1 mb-12 lg:mb-0'
        >
          <h2 className='h2 text-accent mb-6 text-center md:text-left'>background.</h2>
          <h3 className='h3 max-w-[455px] m-0 text-center md:text-left'>
            I'm a Front-end Dev.
          </h3>
          <p className='leading-5 text-justify mb-8'>
            Check out my resume, but if you want to meet me closely contact me.
          </p>
          <div className='flex flex-col md:flex-row gap-x-6 gap-y-2 items-center'>
            <div>
              {cvLinks.map(({link,title}, i) => 
                <a key={i} href={link} className='flex items-center gap-2'>
                  <BsDownload />  
                  <button className='cursor-pointer'>
                    {title}
                  </button>
                </a>
              )}
            </div>
            <a href="https://github.com/propanibutan?tab=repositories" target="_blank" rel="noreferrer">
              <button className='text-gradient btn-link cursor-pointer'>
                See my work
              </button>
            </a>
            <a href="mailto:zalas.patrycja@gmail.com">
              <button className='btn btn-sm'>Contact me</button>
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
  );
};

export default Resume;
